import { formItems } from "../informationRequest/informationRequestConfiguration";

// The requests that list estate items, by request identifier: the gate question that opens the list,
// the types of item it adds, any wider set it lists, and the list's label.
//
// The proper fix is for the staff app to send item_types per card row from dashboard_cards.json, and
// the Go backend to store and serve them on the doable, as #2275 does for section and label. Then
// delete this map.
export const ESTATE_ITEM_ROWS = {
  ask_client_1_about_money_and_investments: {
    gateField: "has_money_or_investments",
    itemTypes: ["bank_account", "shares_and_investments"],
    listLabel: "Accounts",
  },
  ask_client_1_about_pensions_and_policies: {
    gateField: "has_pensions_or_policies",
    itemTypes: ["pension", "life_insurance"],
    listLabel: "Pensions and policies",
  },
  ask_client_1_about_credit_cards_and_loans: {
    gateField: "has_credit_cards_or_loans",
    itemTypes: ["credit_card", "loan", "overdraft"],
    // The staff app answers this gate from these too, so the client sees the debts behind its Yes
    listedTypes: ["credit_card", "loan", "overdraft", "arrears", "tax_owed", "other_liability"],
    listLabel: "Debts",
  },
  ask_client_1_about_valuables_and_household_goods: {
    gateField: "has_valuables",
    itemTypes: ["household_goods"],
    listLabel: "Valuables",
  },
  // The vehicle form sends finance as a loan, which the credit cards and loans row lists
  ask_client_1_about_vehicles: { gateField: "has_vehicles", itemTypes: ["vehicle"], listLabel: "Vehicles" },
  ask_client_1_about_money_owed_to_the_estate: {
    gateField: "has_money_owed_to_the_estate",
    itemTypes: ["money_owed_to_deceased"],
    listLabel: "Money owed to them",
  },
};

// A doable doesn't carry its request identifier, so this finds the row by its gate question, which
// only that request asks
export const estateItemRowFor = (configuration) => {
  const { fieldsByIdentifier } = formItems(configuration);
  return Object.values(ESTATE_ITEM_ROWS).find((row) => fieldsByIdentifier.has(row.gateField));
};
